import React, { createContext, useContext, useState } from "react";

import { getHighlightsPlaylistId } from "../constants/youtube";
import { getPlaylistVideos } from "../utils/googleApi/youtube";
import { writeCache, readAll, readCache } from "../utils/cache";

const CACHE_KEY = "highlights_cache";

const HighlightsContext = createContext({
  seasonHightlights: {},
});

export const useHighlightsContext = () => {
  return useContext(HighlightsContext);
};

export const HighlightsProvider = ({ children }) => {
  const [seasonHightlights, setSeasonHightlights] = useState(() => {
    const restored = readAll({ cacheKey: CACHE_KEY });
    return restored || {};
  });

  const loadSeasonHighlights = async (seasonId) => {
    if (seasonHightlights[seasonId]) return; //already exists in state

    console.log("Loading highlights for season", seasonId);

    // check aggregated cache first
    const cached = readCache({ cacheKey: CACHE_KEY, itemKey: seasonId });
    if (cached) {
      setSeasonHightlights((prev) => ({ ...prev, [seasonId]: cached }));
      return;
    }

    // A season without a playlist has no videos; record that instead of asking YouTube, so the
    // page can tell "empty" from "still loading".
    const playlistId = getHighlightsPlaylistId(seasonId);
    if (!playlistId) {
      setSeasonHightlights((prev) => ({ ...prev, [seasonId]: [] }));
      return;
    }

    const videos = await getPlaylistVideos({ playlistId });

    setSeasonHightlights((prevValue) => {
      prevValue[seasonId] = videos;
      return { ...prevValue };
    });

    writeCache({ cacheKey: CACHE_KEY, itemKey: seasonId, value: videos });
  };

  return (
    <HighlightsContext.Provider value={{ seasonHightlights, loadSeasonHighlights }}>
      {children}
    </HighlightsContext.Provider>
  );
};
